import styles from "../../../styles/charts/chartStyle.module.css";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { toShortNumber } from "../../../lib/util";

interface LineChartProps {
  title?: string;
  labels?: any[];
  chartData: any[];
  xLabel?: string;
  yLabel?: string;
  type?: "area" | "line";
  xAxisDateTime?: boolean;
}
const LineChart = (props: LineChartProps) => {
  const { type = "line", xAxisDateTime = false, xLabel, yLabel, title } = props;

  let options = {
    chart: {
      type: "area",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: xLabel,
            headerValue: yLabel,
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      tickPlacement: "on",
      type: xAxisDateTime ? "datetime" : undefined,
      categories: props.labels,
      labels: {
        show: true,
        trim: true,
        hideOverlappingLabels: false,
        rotate: 0, //-30
        tickAmount: 5,
        tickPlacement: "between",
      },
      title: {
        text: props.xLabel,
        offsetY: 90,
        style: {
          color: "#000000",
          fontWeight: "500",
          fontSize: "16px",
        },
      },
    },
    yaxis: {
      labels: {
        show: true,
        trim: true,
        hideOverlappingLabels: false,
        rotate: 0,
        formatter: toShortNumber,
        tickAmount: 5,
        tickPlacement: "between",
      },
      title: {
        text: props.yLabel,
        offsetY: 0,
        style: {
          color: "#000000",
          fontWeight: "500",
          fontSize: "16px",
        },
      },
    },
    stroke: {
      show: true,
      // curve: "smooth",
      // lineCap: "butt",
      colors: undefined,
      width: 3,
      // dashArray: 0,
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      onItemClick: {
        toggleDataSeries: false,
      },
    },

    colors: ["#008FFB", "#01E396", "#FEB019", "#FF4560", "#775DD0"],
    noData: {
      text: "Loading...",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
  };

  let series = props.chartData;

  return (
    <ReactApexChart
      className={styles.the_chart}
      options={options as ApexOptions}
      series={series}
      type={type}
    />
  );
};

export default LineChart;
